import React from 'react';
import { Check } from 'lucide-react';
import styles from './ListItem.module.css';

export interface ListItemProps {
  label: string;
  description?: string;
  isSelected?: boolean;
  onClick: () => void;
}

const ListItem: React.FC<ListItemProps> = ({ label, description, isSelected = false, onClick }) => (
  <button
    type="button"
    role="option"
    aria-selected={isSelected}
    onClick={onClick}
    className={[
      styles.item,
      'w-full px-3 py-2 text-left flex items-center justify-between gap-3 rounded-lg',
      isSelected ? 'bg-primary-50 text-primary-700' : 'text-gray-700',
    ].join(' ')}
  >
    <div className="flex-1 min-w-0">
      <div className="font-medium leading-tight">{label}</div>
      {description && (
        <div className="text-xs text-gray-500 mt-0.5 leading-tight">{description}</div>
      )}
    </div>
    {isSelected && (
      <Check size={16} aria-hidden="true" className="flex-shrink-0 text-primary-600" />
    )}
  </button>
);

export default ListItem;
